const PrivacyPolicy = () => {
  return (
    <div>
      privacy
    </div>
  )
}

export default PrivacyPolicy
